import { pxToRem } from 'styles/functions'

// Vaudreuil-Dorion
// moncircuitdartvd
const Theme = {
  body_background_color: '#000000',

  header_border_color: 'transparent',
  header_full_height: true,

  logo_image_url: 'moncircuitdartvd.png',

  token_hidden: true,
  number_hidden: true,

  text_font: `'Barlow Semi Condensed', sans-serif`,

  title_font: `'Barlow', sans-serif`,
  title_margin: `${pxToRem(15)} 0 ${pxToRem(10)} ${pxToRem(10)}`,

  text_size: 15,
  text_lineheight: 24,

  button_color: '#000000',
  button_border_width: 3,
  button_text_size: 14,
  button_text_weight: 600,

  footer_border_color: 'lightgray',
}

export default Theme
